import { gql } from "@/gql";
import { useMutation } from "@apollo/client/react";

export const WARM_UP_SESSION = gql(`
  mutation WarmUpSession {
    warmUpSession {
      dealerAccountIds
      sessionId
    }
  }
`);

/**
 * Fires the login-time background device sync for all of the user's dealers.
 * Fire-and-forget; per-dealer status arrives via `deviceSyncStatusChanged`.
 */
export const useWarmUpSession = () =>
  useMutation(WARM_UP_SESSION, {
    context: { skipGlobalError: true },
  });
